import type { QuizModel } from '../models/quiz.model';

export default defineNuxtPlugin(async () => {
  const quiz = ref<QuizModel>(await import('../configs/quiz_v1'));

  async function getQuiz(quizVersion: string) {
    switch (quizVersion) {
      case '2':
        quiz.value = await import('../configs/quiz_v2');
        break;
      case '1':
      default:
        quiz.value = await import('../configs/quiz_v1');
        break;
    }
  }

  return {
    provide: {
      quiz,
      getQuiz,
    },
  };
});
